import {ApolloLink} from '@apollo/client';

import type {NextLink} from '@apollo/client';
import type {InternalOperation} from 'src/internal/apollo/types';
import type {GraphQlDocument} from 'src/internal/shared/graphql/types/document';

export default function createRuntimePermissionsCheckLink(): ApolloLink {
  return new ApolloLink(function runtimePermissionsCheckLink<
    TDocumentNode extends GraphQlDocument<any, any, any>,
  >(operation: InternalOperation<TDocumentNode>, forward: NextLink) {
    return forward(operation);
  });
}
